import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { ChallengeCheckoutInfo } from '../interfaces/checkoutInfo';
import { checkoutService } from '../services/checkoutService';

class ChallengeCheckoutStore {
  challengeCheckoutInfo: ChallengeCheckoutInfo | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.challengeCheckoutInfo = null;
  }

  setChallengeCheckoutInfo(challengeCheckoutInfo: ChallengeCheckoutInfo) {
    this.challengeCheckoutInfo = challengeCheckoutInfo;
  }

  async subscribeToChallenge(participantId: number) {
    const response = await checkoutService.subscribeToChallenge(participantId);

    this.setChallengeCheckoutInfo(response);
  }
}

const challengeCheckoutStore = new ChallengeCheckoutStore();
resetAllStore.addResetMethod(challengeCheckoutStore.setDefaultValues);

export { challengeCheckoutStore, ChallengeCheckoutStore };
